import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { useCarousel } from "./CarouselContext";
import useStyle from "./Numbers.style";
export var Numbers = function() {
    var ref = useCarousel(), _state = ref.state, cols = _state.cols, slideIndex = _state.slideIndex, slideCount = _state.slideCount, isRtl = _state.isRtl, insetControls = _state.insetControls;
    var wrapper = useStyle({
        isRtl: isRtl,
        insetControls: insetControls
    }).wrapper;
    if (cols !== 1) {
        return null;
    }
    return _jsxs("div", {
        css: wrapper,
        children: [
            slideIndex + 1,
            "/",
            slideCount
        ]
    });
};
export default Numbers;
